export const getYear = (val) => {
  const joinDate = new Date(val);
  const dateStr = joinDate.toDateString();
  const joinDateDate = new Date(dateStr);
  const joinYear = joinDateDate.getFullYear();

  return joinYear;
};
